module.exports = __webpack_public_path__ + "static/media/imgIdea.9278c8e6.svg";